import { jwtDecode } from "jwt-decode";

const REDIRECT_KEY = "postLoginRedirect";

// True when a customer login token is stored and not expired.
export const hasValidCustomerLogin = () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return false;
    const { id, exp } = jwtDecode(token);
    return !!id && (!exp || exp * 1000 > Date.now());
  } catch {
    return false;
  }
};

// Send the customer to /login and come back to `returnTo` afterwards.
export const goToLogin = (navigate, returnTo) => {
  sessionStorage.setItem(REDIRECT_KEY, returnTo);
  navigate("/login");
};

// Where to go after login (or closing the login page). Only same-site paths
// are allowed, so a crafted value can't send the customer to another site.
export const consumePostLoginRedirect = () => {
  const target = sessionStorage.getItem(REDIRECT_KEY);
  sessionStorage.removeItem(REDIRECT_KEY);
  return target && target.startsWith("/") && !target.startsWith("//") ? target : "/";
};
